export const projects = [
  {
    id: 1,
    title: '○○시 △△천 하천정비 사업',
    location: '경기도 ○○시',
    year: '2023년',
    description: '총 연장 1.2km 구간의 하천 호안 보호 공사',
    image: 'https://public.readdy.ai/ai/img_res/ea23fa47f552a1918514431583848ff4.jpg',
    category: '하천정비'
  },
  {
    id: 2,
    title: '□□강 침식방지 공사',
    location: '충청남도 □□군',
    year: '2023년',
    description: '급경사 구간 침식방지 및 호안 안정화 공사',
    image: 'https://readdy.ai/api/search-image?query=Steep%20slope%20river%20erosion%20control%20project%20with%20gabion%20mattress%20system%20installed%20on%20hillside%2C%20robust%20wire%20mesh%20structure%20filled%20with%20large%20stones%20preventing%20soil%20erosion%2C%20mountain%20river%20setting%2C%20flowing%20water%20below%2C%20professional%20construction%20quality%2C%20technical%20engineering%20solution%2C%20natural%20landscape%20integration%2C%20realistic%20photography&width=800&height=600&seq=proj2new&orientation=landscape',
    category: '침식방지'
  },
  {
    id: 3,
    title: '◇◇천 생태하천 조성사업',
    location: '전라북도 ◇◇시',
    year: '2022년',
    description: '생태 친화적 하천 복원 및 호안 보호 공사',
    image: 'https://readdy.ai/api/search-image?query=Ecological%20river%20restoration%20project%20with%20gabion%20mattress%20creating%20natural%20habitat%2C%20crystal%20clear%20water%20flowing%20through%20restored%20riverbed%2C%20aquatic%20plants%20growing%20naturally%2C%20small%20fish%20visible%20in%20water%2C%20lush%20green%20vegetation%20on%20both%20banks%2C%20natural%20stone%20gabion%20structures%20blending%20with%20environment%2C%20sustainable%20engineering%2C%20peaceful%20atmosphere%2C%20professional%20environmental%20project%20photography&width=800&height=600&seq=proj3new&orientation=landscape',
    category: '생태하천'
  },
  {
    id: 4,
    title: '☆☆시 하천 재해예방 사업',
    location: '강원도 ☆☆시',
    year: '2022년',
    description: '홍수 피해 예방을 위한 하천 보강 공사',
    image: 'https://readdy.ai/api/search-image?query=Flood%20prevention%20river%20reinforcement%20project%20with%20heavy-duty%20gabion%20mattress%20installation%2C%20robust%20protective%20structure%20along%20riverbank%2C%20mountain%20river%20with%20strong%20water%20flow%2C%20disaster%20prevention%20engineering%2C%20reinforced%20concrete%20foundation%20visible%2C%20professional%20construction%20site%2C%20safety%20barriers%2C%20technical%20precision%2C%20engineering%20excellence%2C%20realistic%20documentation%20photography&width=800&height=600&seq=proj4new&orientation=landscape',
    category: '재해예방'
  },
  {
    id: 5,
    title: '●●천 호안 정비공사',
    location: '경상남도 ●●군',
    year: '2021년',
    description: '노후 호안 개선 및 안정화 공사',
    image: 'https://readdy.ai/api/search-image?query=Riverbank%20stabilization%20project%20showing%20newly%20installed%20gabion%20mattress%20revetment%20system%2C%20improved%20structural%20stability%20with%20wire%20mesh%20and%20natural%20stone%20fill%2C%20rural%20river%20setting%20with%20agricultural%20fields%20nearby%2C%20clear%20water%20flowing%20smoothly%2C%20renovated%20embankment%2C%20professional%20engineering%20work%2C%20quality%20construction%20result%2C%20realistic%20project%20photography&width=800&height=600&seq=proj5new&orientation=landscape',
    category: '호안정비'
  },
  {
    id: 6,
    title: '▲▲강 하상 안정화 사업',
    location: '충청북도 ▲▲시',
    year: '2021년',
    description: '하상 침식 방지 및 구조 안정화 공사',
    image: 'https://readdy.ai/api/search-image?query=River%20bed%20stabilization%20project%20with%20gabion%20mattress%20preventing%20riverbed%20erosion%2C%20stable%20foundation%20structure%20visible%20underwater%2C%20natural%20stones%20arranged%20in%20wire%20mesh%2C%20flowing%20water%20showing%20stable%20current%2C%20professional%20engineering%20solution%20preventing%20scouring%2C%20technical%20precision%2C%20construction%20excellence%2C%20realistic%20underwater%20and%20surface%20view%2C%20high%20quality%20project%20documentation&width=800&height=600&seq=proj6new&orientation=landscape',
    category: '하상안정화'
  }
];
